import React, { useRef, useState } from "react";

interface SignaturePadProps {
  onSave: (signatureDataUrl: string) => void;
}

const SignaturePadControl: React.FC<SignaturePadProps> = ({ onSave }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [isDrawing, setIsDrawing] = useState<boolean>(false);

  const startDrawing = (
    event: React.MouseEvent<HTMLCanvasElement, MouseEvent>
  ) => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    setIsDrawing(true);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const endDrawing = () => {
    setIsDrawing(false);
    saveSignature();
  };

  const draw = (event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => {
    if (!isDrawing || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const clearSignature = () => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    onSave("");
  };

  const saveSignature = () => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const signatureDataURL = canvas.toDataURL(); // Convert canvas to data URL
    onSave(signatureDataURL); // Send signature data back to parent
  };

  return (
    <div className="mar-t10">
      <canvas
        ref={canvasRef}
        width={500}
        height={120}
        style={{ border: "1px solid #ddd", borderRadius: 5 }}
        onMouseDown={startDrawing}
        onMouseUp={endDrawing}
        onMouseMove={draw}
      />
      <div className="help-btns" style={{ maxWidth: 500 }}>
        <a onClick={clearSignature}>Clear</a>
        {/* <a onClick={saveSignature}>Save</a> */}
      </div>
    </div>
  );
};

export default SignaturePadControl;
